<template>
    <div class="flex border-collapse border-b border-gray-200 text-gray-600 font-normal ">
        <div class="border-l border-r flex-1 py-1 px-2 relative" :class="getClass(sendRequest)">
            <div class="flex flex-1 truncate">
                {{ sendRequest.handle }}
            </div>
            <div class="text-xs pt-2 absolute right-1 top-0 text-gray-300 hover:text-gray-600 overflow-visible"
                 v-if="sendRequest.message">
                <ui-dropdown menu-class="p-3 w-96">
                    <template #default="{ toggle,open,close }">
                        <i class="fas fa-sticky-note" @mouseover="open" @mouseout="close"></i>
                    </template>
                    <template #menu="{ close }">
                        <div class="ml-0 flex">
                            <p class="text-xs font-medium text-gray-400 truncate">
                                Message sent:
                            </p>
                        </div>
                        <div class="ml-0 flex w-full truncate whitespace-pre-wrap" v-text="sendRequest.message">
                        </div>
                    </template>
                </ui-dropdown>
            </div>
        </div>
        <div class="w-40 border-r border-gray-200 py-1 px-2" :class="getClass(sendRequest)">
            {{ moment(sendRequest.requested.at).format('DD/MM/YYYY HH:mm') }}
        </div>
        <div class="border-r border-gray-200 py-1 px-2 relative flex-1" :class="getClass(sendRequest)">
            <send-request-action :sendRequest="sendRequest"/>
            <div class="text-xs pt-2 absolute right-1 top-0 text-gray-300 hover:text-gray-600 overflow-visible">
                <ui-dropdown menu-class="p-3 w-60">
                    <template #default="{ toggle,open,close }">
                        <i class="fa fa-info-circle" @mouseover="open" @mouseout="close"></i>
                    </template>
                    <template #menu="{ close }">
                        <div class="ml-0 flex justify-end">
                            <p class="text-xs font-medium text-gray-400 truncate">
                                Requested: <span
                                v-text="moment(sendRequest.requested.at).format('YYYY-MM-DD HH:mm:ss')"
                                v-if="sendRequest.requested.at"
                                class="text-brand"></span>
                                <span v-else class="text-gray-500">-- Not yet requested --</span>
                            </p>
                        </div>
                        <div class="ml-0 flex justify-end">
                            <p class="text-xs font-medium text-gray-400 truncate">
                                by: <span
                                v-text="sendRequest.requested.by.user"
                                v-if="sendRequest.requested.at"
                                class="text-brand"></span>
                                <span v-else class="text-gray-500"></span>
                            </p>
                        </div>
                        <div class="ml-0 flex justify-end">
                            <p class="text-xs font-medium text-gray-400 truncate">
                                Sent At: <span
                                v-text="moment(sendRequest.sentAt).format('YYYY-MM-DD HH:mm:ss')"
                                v-if="sendRequest.sentAt"
                                class="text-brand"></span>
                                <span v-else class="text-gray-500">-- Not yet sent --</span>
                            </p>
                        </div>
                        <div class="ml-0 flex justify-end">
                            <p class="text-xs font-medium text-gray-400 truncate">
                                Viewed At: <span
                                v-text="moment(sendRequest.viewedAt).format('YYYY-MM-DD HH:mm:ss')"
                                v-if="sendRequest.viewedAt"
                                class="text-brand"></span>
                                <span v-else class="text-gray-500">-- Not yet viewed --</span>
                            </p>
                        </div>
                    </template>
                </ui-dropdown>
            </div>
        </div>
        <div class="w-6 flex-shrink-0 ml-2 mt-1">
            <ui-dropdown menu-class="p-3 w-56" v-if="sendRequest.status !=='Revoked'">
                <template #default="{ toggle }">
                    <button @click="toggle"
                            class="w-5 h-5 flex items-center justify-center text-gray-300 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:z-10 relative rounded">
                        <i class="fa fa-ellipsis-h fa-fw"></i>
                    </button>
                </template>
                <template #menu="{ close }">
                    <ui-dropdown-item icon="fas fa-route" @click="$emit('resend',sendRequest);close()">
                        Resend Sent item
                    </ui-dropdown-item>
                    <ui-dropdown-divider v-if="sendRequest.status!=='Revoked'"></ui-dropdown-divider>
                    <ui-dropdown-item icon="fas fa-user-alt-slash" @click="$emit('revoke',sendRequest); close()">
                        Revoke Sent item
                    </ui-dropdown-item>
                </template>
            </ui-dropdown>
        </div>
    </div>
</template>

<script>

import moment from "moment";
import UiDropdown from "../ui/UiDropdown.vue";
import UiDropdownItem from "../ui/UiDropdownItem.vue";
import UiDropdownDivider from "../ui/UiDropdownDivider.vue";

export default {
    computed: {
        moment() {
            return moment
        }
    },
    components: {UiDropdownDivider, UiDropdownItem, UiDropdown},
    props: {
        sendRequest: Object,
    },
    data() {
        return {}
    },
    methods: {
        getClass(sendRequest) {
            if (sendRequest.status === 'Revoked' || sendRequest.status === 'Invalidated') {
                return ' line-through'
            }
            return '';
        },
    },
}
</script>
